import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const { Text } = Typography;

export default function LoginPage() {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (v: { email: string; password: string }) => {
    setError('');
    setLoading(true);
    try {
      await login(v.email, v.password);
    } catch (err: any) {
      // 429 = troppi tentativi: va detto, altrimenti sembra che la password
      // sia sbagliata e l'utente continua a riprovare peggiorando le cose.
      setError(
        err?.response?.status === 429
          ? 'Troppi tentativi. Attendi un minuto e riprova.'
          : err?.response?.data?.message || 'Email o password non corretti.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card" variant="borderless">
        <div className="login-brand">
          <img src="/logo.png" alt="Molti Like" />
          <Text type="secondary">Pannello di controllo</Text>
        </div>

        {error && (
          <Alert type="error" showIcon message={error} style={{ marginBottom: 18 }} />
        )}

        <Form layout="vertical" onFinish={submit} requiredMark={false} size="large">
          <Form.Item
            name="email" label="Email"
            rules={[
              { required: true, message: 'Inserisci la tua email' },
              { type: 'email', message: 'Indirizzo email non valido' },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: '#98A1B8' }} />}
              placeholder="admin@moltilike.it"
              autoComplete="username"
              autoFocus
            />
          </Form.Item>

          <Form.Item
            name="password" label="Password"
            rules={[{ required: true, message: 'Inserisci la password' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#98A1B8' }} />}
              placeholder="La tua password"
              autoComplete="current-password"
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={loading} block size="large">
            Accedi
          </Button>
        </Form>
      </Card>
    </div>
  );
}
